module.exports = __webpack_public_path__ + "static/media/2025_composite.c6ec4a6f.jpg";